<template>
  <div v-if="stock_out && stock_out.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('StockOutOrders', 'view')">
        <template v-slot:activator="{ on, attrs }">
          <!-- 明细跳转 -->
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="pageType == 1 ? '/#/stock-out-orders/' + stock_out.id : '/#/production-stock-out/' + stock_out.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("stockOutOrders.ObjectName")])
        }}</span>
      </v-tooltip>
      <!-- 编辑 -->
      <v-tooltip top v-if="showEdit && stock_out.status == 2 && $permission.permissionAllow('StockInOrders', 'edit')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="pageType == 1 ? $router.push('/stock-out-orders/' + stock_out.id + '/edit') : $router.push('/production-stock-out/' + stock_out.id + '/edit');"
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("stockInOrders.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("stockInOrders.actions.editStockIN") }}</span>
      </v-tooltip>
      <!-- 出库 -->
      <v-tooltip
        top
        v-if="
          showComplete && stock_out.actions && stock_out.actions.out_complete && $permission.permissionAllow('StockOutOrders', 'out')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="out()"
          >
            {{ $t("stockOutOrders.actions.stockOut") }}
          </v-btn>
        </template>
        <span>{{ $t("stockOutOrders.actions.stockOut") }}</span>
      </v-tooltip>
      <!-- 重新推送 -->
      <v-tooltip
        top
        v-if="
          showRePush && stock_out.actions && stock_out.actions.out_re_push
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('rePush')"
          >
            {{ $t("stockOutOrders.actions.rePush") }}
          </v-btn>
        </template>
        <span>{{ $t("stockOutOrders.actions.rePush") }}</span>
      </v-tooltip>
      <!-- 作废 -->
      <v-tooltip
        top
        v-if="showCancel && stock_out.actions && stock_out.actions.out_cancel && $permission.permissionAllow('StockOutOrders', 'cancel')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('cancel')"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("stockOutOrders.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("stockOutOrders.actions.cancelStockOUT") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="$permission.permissionAllow('StockOutOrders', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doPrint('stockOUTDetailPrint')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("stockOutOrders.Fields.print") }}
          </v-btn>
        </template>
        <span>{{ $t("stockOutOrders.Fields.print") }}</span>
      </v-tooltip>
       <v-tooltip
        top
        v-if="showExport && $permission.permissionAllow('StockOutOrders', 'detailExport')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="exportDetail()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("stockOutOrders.Fields.export") }}
          </v-btn>
        </template>
        <span>{{ $t("stockOutOrders.Fields.export") }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StockOuts from "@/api/stock_out_orders";
import Shops from "@/api/shops";
import i18n from "@/i18n";
export default {
  name: "StockOrderOUTActions",

  props: {
    pageType: Number,
    stock_out: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showCancel: Boolean,
    showComplete: Boolean,
    showExport:Boolean,
    showRePush: Boolean,
  },

  components: {},

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings", "accountUser"]),
  },

  data: () => ({}),

  methods: {
    actionMethod(mode) {
      if (mode == "rePush") return StockOuts.rePushReturnOrder(this.stock_out.id)
      if (mode == "cancel") return StockOuts.cancel(this.stock_out.id);
    },
    doAction(mode) {
      // this.$permission.checkAccountExpired().then(
      // function () {
      this.actionMethod(mode).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (this.pageType == 1) {
              if (this.$route.path == "/stock-out-orders") {
                this.$emit("done");
              } else {
                this.$router.replace("/stock-out-orders");
              }
            }else if (this.pageType ==2) {
              if (this.$route.path == "/production-stock-out") {
                this.$emit("done");
              } else {
                this.$router.replace("/production-stock-out");
              }
            }
          }
        }.bind(this)
      );
      // }.bind(this)
      // );
    },

    out() {
      // if (
      //   this.stock_out.third_return &&
      //   this.stock_out.third_return.push_platform == 1010
      // ) {
      //   this.dialog = true;
      // } else if (this.stock_out.type == 1 || this.stock_out.type == 2) {

      Shops.checkAction(1).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              if (this.pageType == 1) {
                this.$router.push("/stock-out-orders/" + this.stock_out.id + "/out");
              } else {
                this.$router.push("/production-stock-out/" + this.stock_out.id + "/out");
              }
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );

      // } else {
      //   this.stockOutDialog = true;
      // }
    },
    // pushAgain() {
    //   StockOuts.pushAgain(this.stock_out.id).then(
    //     function (response) {
    //       if (response.data.status.isOK()) {
    //         this.$emit("done");
    //       }
    //     }.bind(this)
    //   );
    // },
    confirmOut() {
      StockOuts.fetchOne(this.stock_out.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            StockOuts.out(response.data.stock_out).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit("done");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    doPrint(mode) {
      switch (mode) {
        case "distributionPrint":
          this.$router.push("/print/stock-order-out-distribution-print/" + this.stock_out.id);
          break;
        case "stockOUTDetailPrint":
          this.$router.push("/print/stock-out-detail-print/" + this.stock_out.id);
          break;
        case "deliveryDetailPrint":
          this.$router.push("/print/deliver-detail-print/" + this.stock_out.id
          );
          break;
      }
    },
    exportDetail() {
      StockOuts.detailExport(this.stock_out.id);
    },
  },

  watch: {},
};
</script>